// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CartHeader: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 19 19" enableBackground="new 0 0 19 19" xmlSpace="preserve">
<path d="M5.22,11.45v1.8c0,0.23,0.22,0.45,0.45,0.45h11.4c0.23,0,0.45-0.23,0.45-0.45s-0.23-0.45-0.45-0.45H6.2v-1.05l10.95-1.8
	c0.23,0,0.38-0.23,0.38-0.38l0.98-5.7c0-0.15,0-0.3-0.08-0.38s-0.23-0.15-0.38-0.15H4.17L3.35,0.8C3.27,0.65,3.05,0.5,2.9,0.5H0.95
	C0.72,0.5,0.5,0.72,0.5,0.95c0,0.3,0.22,0.52,0.45,0.52h1.58l0.83,2.47L5.22,11.45z M17.45,4.32l-0.83,4.8L6.05,10.85L4.4,4.33
	L17.45,4.32z M5.23,14.68c-1.05,0-1.88,0.82-1.88,1.87s0.82,1.95,1.88,1.95s1.88-0.83,1.88-1.88S6.28,14.68,5.23,14.68z M5.23,17.52
	c-0.53,0-0.97-0.45-0.97-0.98s0.45-0.98,0.97-0.98s0.97,0.45,0.97,0.98S5.75,17.52,5.23,17.52z M16.62,14.67
	c-1.05,0-1.88,0.82-1.88,1.88s0.82,1.88,1.88,1.88s1.88-0.83,1.88-1.88S17.67,14.67,16.62,14.67z M16.62,17.52
	c-0.52,0-0.98-0.45-0.98-0.98s0.45-0.98,0.98-0.98s0.98,0.45,0.98,0.98S17.15,17.52,16.62,17.52z"/>
</svg>;
};

export default React.memo(CartHeader);
